export default __webpack_public_path__ + "static/it-simple-d1a19a1dc5a61f8068c31cb9199f8170.svg";